import styled from 'styled-components';

import { Bar } from 'basics/loaders/ContentPlaceholder/ContentPlaceholder.styled';

import { respondDown } from 'styles/mixins';
import { Breakpoints } from 'styles/style-constants';

import { Container } from '../Delegatee/Delegatee.styled';

export const Card = styled(Container)`
    cursor: default;
`;

export const Avatar = styled(Bar)`
    margin-right: 1.6rem;
`;

export const VotingPower = styled.div`
    margin-left: auto;
    display: flex;
    flex-direction: column;
    gap: 0.4rem;

    ${respondDown(Breakpoints.lg)`display: none;`}
`;

export const MobileVotingPower = styled.div`
    display: none;

    ${respondDown(Breakpoints.lg)`
        display: flex;
        flex-direction: column;
        gap: 0.4rem;
        margin-top: 1.6rem;
        padding: 0.2rem 0;
    `}
`;

export const Description = styled.div`
    display: flex;
    flex-direction: column;
    gap: 0.4rem;
    margin-top: 2.4rem;
    padding: 0.2rem 0;

    & > :nth-child(n + 3) {
        display: none;
    }

    ${respondDown(Breakpoints.md)`
        & > :nth-child(n + 3) { display: block; }
    `}
`;

export const FooterValue = styled.div`
    display: flex;
    align-items: center;
    height: 1.6rem;
    ${respondDown(Breakpoints.md)`& + & { display: none; }`}
`;
